import React from 'react';

import Item from './Item';

const Sections = (props) => {
	return (
		<div className="sections">
			<div className="row">
				<div className="col-md-3">
					<Item {...props} />
				</div>
			</div>
		</div>
	);
}

export default Sections;